module.exports = __webpack_public_path__ + "static/media/Mod3.4b897246.png";